import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Performances from './components/Performances';
import Contact from './components/Contact';
import Repertoire from './components/Repertoire';

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow container mx-auto px-4 py-8 mb-16">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/performances" element={<Performances />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/repertoire" element={<Repertoire />} />
          </Routes>
        </main>
        <footer className="bg-piano-black text-ivory py-6">
          <div className="container mx-auto px-4 text-center">
            <p> {new Date().getFullYear()} Piano Artist Portfolio. All rights reserved.</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
